import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component, Children } from 'react';
import { matchSorter } from 'match-sorter';
import Box from '../Box';
import Menu from '../Menu';
import HeadingUppercase from '../HeadingUppercase';
import StackView from '../StackView';
import Text from '../Text';
import { shallowEqual } from '../utils';
import ComboboxItem from './ComboboxItem';

var defaultRenderEmpty = function defaultRenderEmpty(value) {
  return /*#__PURE__*/React.createElement(Menu.Item, null, "No results for", /*#__PURE__*/React.createElement(Text, {
    as: "span",
    inline: true,
    color: "grey-7"
  }, "\"", value, "\""));
};

var defaultRenderItem = function defaultRenderItem(item) {
  return /*#__PURE__*/React.createElement(ComboboxItem, {
    value: item,
    children: item ? String(item) : null
  });
};

var ComboboxItems = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ComboboxItems, _Component);

  function ComboboxItems(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      sortedItems: _this.getSortedItems(props)
    };
    return _this;
  }

  var _proto = ComboboxItems.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    if (lastProps.value !== this.props.value || !shallowEqual(lastProps.items, this.props.items) || !shallowEqual(lastProps.filter, this.props.filter)) {
      this.setState({
        sortedItems: this.getSortedItems(this.props)
      });
    }
  };

  _proto.getSortedItems = function getSortedItems(_ref) {
    var items = _ref.items,
        value = _ref.value,
        filter = _ref.filter;
    return matchSorter(items, value.length > 0 ? value : '', filter);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        filter = _this$props.filter,
        items = _this$props.items,
        renderEmpty = _this$props.renderEmpty,
        renderItem = _this$props.renderItem,
        title = _this$props.title,
        value = _this$props.value,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["filter", "items", "renderEmpty", "renderItem", "title", "value"]);

    var sortedItems = this.state.sortedItems;
    return /*#__PURE__*/React.createElement(Box, restProps, title && /*#__PURE__*/React.createElement(StackView, {
      paddingHorizontal: 1,
      paddingVertical: 0.5
    }, /*#__PURE__*/React.createElement(HeadingUppercase, null, title)), Children.toArray(sortedItems.length > 0 ? sortedItems.map(function (item, index) {
      return renderItem(item, index);
    }) : typeof renderEmpty === 'function' ? renderEmpty(value) : renderEmpty));
  };

  return ComboboxItems;
}(Component);

_defineProperty(ComboboxItems, "displayName", 'Combobox.Items');

_defineProperty(ComboboxItems, "defaultProps", {
  value: '',
  renderEmpty: defaultRenderEmpty,
  renderItem: defaultRenderItem
});

export default ComboboxItems;